import classnames from 'classnames';
import { KKDAY_URL } from '@/utils/links';

import Title from '@/components/atoms/Title';
import Button from '@/components/atoms/Button';

import styles from './index.module.css';

export interface SectionHowToProp {
    className?: string;
}

const SectionHowTo: React.FC<SectionHowToProp> = ({ className }) => {
    return (
        <div className={classnames(styles.gameIntro, className)}>
            <Title>怎麼玩</Title>
            <div className={styles.itemWrapper}>
                <div className={styles.item}>
                    <div className={styles.icon}>
                        <img src="/images/intro-2.png" alt="intro" />
                    </div>
                    <div className={styles.label}>實境走讀 × 聲音劇場</div>
                    <div className={styles.context}>故事跟著你的腳步，在老街轉角一幕幕上演</div>
                </div>
                <div className={styles.item}>
                    <div className={styles.icon}>
                        <img src="/images/intro-1.png" alt="intro" />
                    </div>
                    <div className={styles.label}>獨家數位互動遊戲</div>
                    <div className={styles.context}>
                        邊聽邊玩，實地互動解開線索、完成角色未完的心願
                    </div>
                </div>
                <div className={styles.item}>
                    <div className={styles.icon}>
                        <img src="/images/intro-3.png" alt="intro" />
                    </div>
                    <div className={styles.label}>帶走別人不知道的恆春</div>
                    <div className={styles.context}>
                        遊客拍照打卡就走的地方，你帶走的是一整座城的記憶與故事
                    </div>
                </div>
            </div>
            <a href={KKDAY_URL} target="_blank" rel="noopener noreferrer">
                <Button className={styles.btn}>搶先體驗</Button>
            </a>
        </div>
    );
};

export default SectionHowTo;
